"use client";


interface HeroSectionProps {
  mediaType: "video";
  mediaUrl: string;
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  mediaUrl,
  title,
  description,
  buttonText,
  buttonLink,
}) => {

  return (
    <>
      <section className="relative flex items-end justify-center h-screen text-white text-center overflow-hidden">
          <>
            <video
              autoPlay
              loop
              muted
              playsInline
              className="absolute inset-0 w-full h-full object-cover"
            >
              <source src={mediaUrl} type="video/mp4" />
              <track
                kind="captions"
                src="/path/to/captions.vtt"
                srcLang="en"
                label="English"
              />
              Your browser does not support the video tag.
            </video>
          </>
        <div className="relative z-10 bg-black bg-opacity-50 p-8 rounded-t-3xl w-full pb-16 mt-auto">
          <h1 className="text-3xl md:text-5xl font-bold mb-4 font-starforge">
            {title.split("<br>")[0]}
            <br />
            {title.split("<br>")[1]}
          </h1>
          <p className="text-lg md:text-xl mb-8 font-['Orbitron']">
            {description}
          </p>
          <a
            href={buttonLink}
            className="px-8 py-3 bg-gradient-to-r from-[#F758D4] to-[#5F16E1] text-white rounded-full font-['Orbitron']"
            aria-label={buttonText}
          >
            {buttonText}
          </a>
        </div>
      </section>
        <script type="application/ld+json" async>
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: title,
            description: description,
            url: buttonLink,
            video: {
              "@type": "VideoObject",
              name: title,
              description: description,
              contentUrl: mediaUrl,
            },
          })}
        </script>
    </>
  );
};

export default HeroSection;
